<div style="width: 200px; padding-left: 30px;">
  <!-- テンプレート -->
  <ng-template #rowsTemplate let-rows>
    <ng-container *ngFor="let row of rows">
      <tr [style.background-color]="row.depth == 0 ? '#EFFFFF' : ''">
        <td>
          <span [style.padding-left.px]="row.depth * 10"> + {{ row.id }} </span>
        </td>
        <td>{{ row.depth }}</td>
        <td>{{ row.name }}</td>
      </tr>
      <ng-container
        *ngTemplateOutlet="rowsTemplate; context: { $implicit: row.children }"
      >
      </ng-container>
    </ng-container>
  </ng-template>
  <!-- テンプレート -->

  <table class="table table-striped table-bordered">
    <thead>
      <tr>
        <td>id</td>
        <td>depth</td>
        <td>name</td>
      </tr>
    </thead>
    <tbody>
      <ng-container
        *ngTemplateOutlet="rowsTemplate; context: { $implicit: stats }"
      >
      </ng-container>
    </tbody>
  </table>
</div>
